export const MOCK_STUDENTS = [
  {
    id: 1,
    name: 'Lorena Days Smith',
    email: 'lorena.smith@example.com',
    avatar: { url: null },
    tag: 'CEFR',
  },
  {
    id: 2,
    name: 'John Doe',
    email: 'john.doe@example.com',
    avatar: { url: null },
    tag: 'TOEFL',
  },
  {
    id: 3,
    name: 'Maria Garcia',
    email: 'maria.garcia@example.com',
    avatar: { url: null },
    tag: 'IELTS',
  },
];

export const MOCK_TESTS = [
  { id: 1, name: 'CEFR Practice Test' },
  { id: 2, name: 'TOEFL Simulation' },
  { id: 3, name: 'IELTS Mock Test' },
];

// New API structure for Phase 2
export const MOCK_STUDENT_PERFORMANCE = {
  user_info: {
    id: 1,
    name: 'Lorena Days Smith',
    avatar_url: null,
    level_label: 'CEFR',
    filter_range: 'last_7_days',
  },

  // Marks from API - defines the Y-axis levels and score mapping
  marks: [
    { score: 0, label: 'A1' },
    { score: 10, label: 'A1+' },
    { score: 20, label: 'A2' },
    { score: 30, label: 'A2+' },
    { score: 40, label: 'B1' },
    { score: 50, label: 'B2' },
    { score: 60, label: 'B2+' },
    { score: 80, label: 'C1' },
    { score: 100, label: 'C2' },
  ],

  chart_history: [
    { date: '2024-03-09', level: 'A2', score_value: 20 },
    { date: '2024-03-10', level: 'B2', score_value: 50 },
    { date: '2024-03-10', level: 'A2+', score_value: 30 },
    { date: '2024-03-10', level: 'B2', score_value: 55 },
    { date: '2024-03-13', level: 'B2', score_value: 60 },
    { date: '2024-03-14', level: 'C1', score_value: 80 },
    { date: '2024-03-15', level: 'C2', score_value: 100 },
  ],

  chart_skills: [
    { label: 'C2', percentage: 60, category: 'advanced' },
    { label: 'C1', percentage: 60, category: 'advanced' },
    { label: 'B2+', percentage: 52, category: 'upper_intermediate' },
    { label: 'B2', percentage: 25, category: 'intermediate' },
    { label: 'B2-', percentage: 20, category: 'low_intermediate' },
    { label: 'A2', percentage: 20, category: 'basic' },
  ],
};

// Category color mapping
export const SKILL_CATEGORY_COLORS = {
  advanced: '#1BD171', // green
  upper_intermediate: '#003366', // dark blue
  intermediate: '#0056b3', // navy blue
  low_intermediate: '#0075EA', // primary blue
  basic: '#FBAB34', // orange
};

// Utility functions to convert marks from API to level maps
/**
 * Converts marks array from API to LEVEL_SCORE_MAP
 * @param {Array<{score: number, label: string}>} marks - Marks from API
 * @returns {Object} Map of label -> score (e.g., { A1: 0, A2: 20 })
 */
export const marksToLevelScoreMap = (marks) => {
  if (!marks || !Array.isArray(marks)) return {};
  return marks.reduce((acc, { score, label }) => {
    acc[label] = score;
    return acc;
  }, {});
};

/**
 * Converts marks array from API to SCORE_LEVEL_MAP
 * @param {Array<{score: number, label: string}>} marks - Marks from API
 * @returns {Object} Map of score -> label (e.g., { 0: 'A1', 20: 'A2' })
 */
export const marksToScoreLevelMap = (marks) => {
  if (!marks || !Array.isArray(marks)) return {};
  return marks.reduce((acc, { score, label }) => {
    acc[score] = label;
    return acc;
  }, {});
};

/**
 * Generates Y_AXIS_LEVELS from marks array
 * Selects evenly distributed levels for display on Y-axis
 * @param {Array<{score: number, label: string}>} marks - Marks from API
 * @param {number} count - Number of levels to show on Y-axis (default: 4)
 * @returns {Array<{score: number, label: string}>} Selected marks for Y-axis
 */
export const marksToYAxisLevels = (marks, count = 4) => {
  if (!marks || !Array.isArray(marks) || marks.length === 0) return [];

  // Sort by score ascending
  const sortedMarks = [...marks].sort((a, b) => a.score - b.score);

  if (sortedMarks.length <= count) {
    return sortedMarks;
  }

  // Select evenly distributed marks including first and last
  const result = [];
  const step = (sortedMarks.length - 1) / (count - 1);

  for (let i = 0; i < count; i++) {
    const index = Math.round(i * step);
    result.push(sortedMarks[index]);
  }

  return result;
};

// Default marks (fallback when API doesn't return marks)
export const DEFAULT_MARKS = [
  { score: 0, label: 'A1' },
  { score: 10, label: 'A1+' },
  { score: 20, label: 'A2' },
  { score: 30, label: 'A2+' },
  { score: 40, label: 'B1' },
  { score: 50, label: 'B2' },
  { score: 60, label: 'B2+' },
  { score: 80, label: 'C1' },
  { score: 100, label: 'C2' },
];

// Legacy exports for backward compatibility (using default marks)
export const LEVEL_SCORE_MAP = marksToLevelScoreMap(DEFAULT_MARKS);
export const SCORE_LEVEL_MAP = marksToScoreLevelMap(DEFAULT_MARKS);
export const Y_AXIS_LEVELS = marksToYAxisLevels(DEFAULT_MARKS, 4).map(
  (m) => m.label
);

export const MOCK_WIDGET = {
  id: 999,
  name: 'Students Progress',
  type: 'STUDENTS_PROGRESS',
  settings: {
    size: 'large',
    default_option: '7',
  },
};

export const MOCKED_DATA = {
  student: null,
  performance: null,
};

export const MOCKED_DATA_WITH_STUDENT = {
  student: {
    id: 1,
    name: 'Lorena Days Smith',
    avatar: { url: null },
    tag: 'CEFR',
  },
  performance: MOCK_STUDENT_PERFORMANCE,
};
